import { render, staticRenderFns } from "./orderResult.vue?vue&type=template&id=18e6478f&scoped=true"
import script from "./orderResult.vue?vue&type=script&lang=js"
export * from "./orderResult.vue?vue&type=script&lang=js"
import style0 from "./orderResult.vue?vue&type=style&index=0&id=18e6478f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e6478f",
  null
  
)

export default component.exports